function toMember(api) {
    return {
        id: api.memberId,
        contactId: api.contactId,
        fullName: api.displayName,
        email: api.email,
        role: api.role,
        isPrincipal: api.isPrimaryContact,
    };
}
export function mapApiHousehold(api) {
    return {
        id: api.householdId,
        name: api.name,
        type: api.householdType,
        greetingFormula: api.greetingFormula,
        members: api.members.map(toMember),
    };
}
